<template>
  <div class="col-12">
    <Search
      :dataNotExist="$lang.dataNotExist"
      :allowFields="$lang.research_queue_fields"
      :url="url"
      :title="$lang.research_list"
      ref="search"
      :hiddenFields="hiddenFields"
      :dynamicButtons="dynamicButtons"
      :showCheckBox="isAdmin(permissions)"
      :filterCatch="true"
      :visibleAdd="false"
      :extraButtons="extraButtons"
      :itemTopHeader="itemTopHeader"
      :handleCheckBoxCondition="handleCheckBoxCondition"
      :getColVariant="getColVariant"
      @getPermisson="getPermissions"
      @rowSelected="rowSelected"
      @rowAllSelected="rowAllSelected"
    />
    <b-modal v-model="view_modal" hide-footer hide-header no-close-on-backdrop>
      <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
      <ResearcherForm
        v-show="!isLoading"
        @closeModal="closeModal"
        @submit="save"
      />
    </b-modal>
    <Confirm
      v-model="confirmModal"
      :cancel-title="$lang.no"
      :description="$lang.researchSearchDeleteAlert"
      :ok-title="$lang.yes"
      :title="$lang.delete_audience"
      @cancel="cancelConfirm"
      @ok="removeItem"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import ResearcherForm from "./../forms/researcherForm";
import Confirm from "@/components/base/confirm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { includes, pathOr } from "ramda";
import { generateApiUrl, generateStoreGetters, isAdmin } from "@/shared/utils";

export default {
  components: {
    Search,
    ResearcherForm,
    Confirm,
    LoadingSpinner,
  },
  inject: ["researchRepository", "researcherRepository"],
  data() {
    return {
      confirmModal: false,
      removeItemId: null,
      isLoading: false,
      loading: false,
      view_modal: false,
      personsSelected: [],
      from_cooperation_type_id: null,
      cooperation_type_id: null,
      permissions: [],
      itemTopHeader: [
        {
          colspan: 7,
          name: this.$lang.researchLang.audience,
        },
        {
          colspan: 1,
          name: this.$lang.researchLang.research_manager,
          variant: "info",
        },
        {
          colspan: 1,
          name: this.$lang.researchLang.researcher,
          variant: "primary",
        },
      ],
      hiddenFields: [
        "created_at.jalali",
        "created_by",
        "updated_by",
        "updated_at",
      ],
      dynamicButtons: [
        {
          name: "edit",
          text: this.$lang.researchLang.researchPlanAction,
          AllowPermissions: ["admin", "edit"],
          iconFont: {
            name: "file-document-edit-outline",
            size: "25",
            class: "text-success",
          },
          showIcon: this.showEditIcon,
          click: this.editRow,
        },
        {
          name: "edit",
          text: this.$lang.resource_data,
          AllowPermissions: ["admin", "edit"],
          iconFont: {
            name: "account-arrow-right-outline",
            size: "25",
            class: "text-primary",
          },
          // دکمه انتخاب محقق به عنوان ارزیاب تحقیق توسط خودش : فغلا این دکمه نمایش داده نمی شود
          showIcon: this.showEditIcon && false,
          click: this.setAssignMeResearcher,
        },
        {
          name: "delete",
          text: this.$lang.resource_data,
          AllowPermissions: ["admin"],
          iconFont: {
            name: "close",
            size: "25",
            class: "text-danger",
          },
          // حذف ارزیاب تحقیق - فعلا به علت اینکه فرایند انتخاب فقط توسط مدیر تحقیق صورت میگیرد و ارزیاب تحقیق در انتخاب نقشی ندارد این گزینه غیر فعال شده است
          showIcon: this.showRemoveIcon && false,
          click: this.showRemoveConfirm,
        },
      ],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["research", "research_queue"]);
    },
    extraButtons() {
      return [
        {
          name: "insert_research_as_research",
          condition:
            this.personsSelected.length &&
            this.insertResearchAsResearchAllowedRoles(),
          title: this.$lang.researchLang.insert_research_as_research,
          click: this.openModalAsResearch,
          iconName: "account-switch-outline",
          badgeCondition: this.personsSelected.length,
          badgeText: this.personsSelected.length,
        },
      ];
    },
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    getItems() {
      this.$refs.search.getItems();
    },
    researchStatusId(item) {
      return pathOr(null, ["research_status", "id"], item);
    },
    getColVariant(index) {
      if (index <= 5) {
        return "";
      }
      if (index <= 6) {
        return "info";
      }
      if (index <= 7) {
        return "primary";
      }
    },
    removeItem() {
      this.patchAssignMeResearcher(this.removeItemId, "disconnect");
    },
    async patchAssignMeResearcher(id, status = "connect") {
      if (!id) {
        return;
      }

      try {
        this.loading = true;
        const url =
          this.$config.api_url +
          this.$config.research.assign_me_researcher.replace("{0}", id);
        const payload = {
          status,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    rowSelected(row) {
      const id = pathOr(null, ["id"], row);
      const alreadySelected = this.personsSelected.find((x) => x === id);
      if (alreadySelected) {
        this.personsSelected = [
          ...this.personsSelected.filter((i) => i !== id),
        ];
      } else {
        this.personsSelected.push(id);
      }
    },
    rowAllSelected(rows) {
      const items = rows.filter((row) => this.handleCheckBoxCondition(row));
      this.personsSelected = [...items.map((item) => item.id)];
    },
    handleCheckBoxCondition(item) {
      return (
        includes(this.researchStatusId(item), [1, 2]) &&
        this.insertResearchAsResearchAllowedRoles()
      );
    },
    showConfirm(removeItemId) {
      this.removeItemId = removeItemId;
      this.confirmModal = true;
    },
    cancelConfirm() {
      this.confirmModal = false;
    },
    async editRow(item) {
      const researcher = !!pathOr(false, ["researcher"], item);
      if (!researcher)
        return this.$notify.warning(
          "شروع تحقیق تا انتخاب ارزیاب تحقیقات امکانپذیر نمی باشد."
        );
      let routeData = this.$router.resolve({
        name: "research_plan_search",
        params: {
          id: item.id,
        },
      });

      window.open(routeData.href, "_blank");
    },
    async save(getPayload) {
      try {
        this.isLoading = true;
        const payload = {
          id: [...this.personsSelected],
          ...getPayload,
        };
        const url =
          this.$config.api_url + this.$config.research.assign_researcher;
        const response = await this.$httpService.patch(url, payload);
        this.personsSelected = [];
        this.$notify.success(response.data.message);
        this.closeModal();
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.view_modal = false;
    },
    openModal() {
      this.from_cooperation_type_id = 7;
      this.cooperation_type_id = 7;
      this.view_modal = true;
    },
    openModalAsResearch() {
      this.from_cooperation_type_id = 8;
      this.cooperation_type_id = 8;

      this.view_modal = true;
    },
    insertResearchAsResearchAllowedRoles() {
      return !!(
        this.roles.includes("modir_arshad_tahghigh") ||
        this.roles.includes("modir_tahghigh") ||
        this.roles.includes("modir_system")
      );
    },
    getPermissions(permissions) {
      this.permissions = [...permissions];
    },
    showEditIcon(item) {
      return !!pathOr(false, ["researcher"], item);
    },
    checkResearchStatusId(item) {
      return this.researchStatusId(item) === 2;
    },
    showRemoveIcon(item) {
      const hasResearcher = !!pathOr(false, ["researcher"], item);
      return hasResearcher && researchStatusId(item) === 2;
    },
    showRemoveConfirm(item) {
      const id = pathOr(null, ["id"], item);
      this.showConfirm(id);
    },
    setAssignMeResearcher(item) {
      const id = pathOr(null, ["id"], item);
      this.patchAssignMeResearcher(id);
    },
  },
};
</script>
